<template>
  <div class="sub-header" :class="[ isBackground ? 'active' : ''] ">
    <div class="sub-header-container">
      <div class="title px-0" v-if="title">{{ title }}</div>
      <slot name="sub-header-tab"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'sub-header',

    props: {
      title: {
        type: String,
      },
      isBackground: {
        type: Boolean,
        default: true,
      },
    },

  };
</script>

<style lang="scss" scoped>
    .sub-header {
      height: 100px;
      width: 100%;
      border-bottom: 1px solid rgba(0, 0, 0, 0.2); 
      padding: 36px 0px 36px 0px;
      background-color: #f5f5f5;

      .sub-header-container {
        max-width: 946px;
        margin: 0 auto;
        padding: 0px 14px 0px 14px;

        .title {
          font-size: 20px;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.54);
          padding: 0px 14px 0px 14px;
          display: inline-block;
        }
      }
    }

    .active {
      padding: 24px;
      background-color: #ffffff;
      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
    }
</style>


// WEBPACK FOOTER //
// SubHeader.vue?d8414430